import {
  PUBLICBOARDMANAGE
} from '../actions/publicBoardManage';
import { reducerPackage } from "../../utils";

export const publicBoardManageList = reducerPackage(PUBLICBOARDMANAGE);

